import { render } from "./SellOrderByCategoryList.vue?vue&type=template&id=34bdf64b&scoped=true"
import script from "./SellOrderByCategoryList.vue?vue&type=script&lang=js"
export * from "./SellOrderByCategoryList.vue?vue&type=script&lang=js"

import "./SellOrderByCategoryList.vue?vue&type=style&index=0&id=34bdf64b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34bdf64b"

export default script